import type { IGetClientShifts, IHeadcountShiftRaw } from '@/api/types';
import type { ISchedule, IScheduleBlock } from '@/types/schedule';
import type { IHeadcountShift } from '@/components/client/scheduling/types';

const transformHeadcountShifts = (shifts: IHeadcountShiftRaw[][], payload: IGetClientShifts): IHeadcountShift[][] =>
  shifts.map<IHeadcountShift[]>(itemArray =>
    itemArray.map(item => ({
      scheduleId: payload.scheduleId,
      shiftId: item.shift_id,
      startBlock: item.start_block,
      endBlock: item.end_block,
      usersScheduled: item.users_scheduled,
      usersDesired: item.users_desired,
      usersOnOffer: item.users_onoffer,
      isPublished: item.is_published,
      hcColor: item.hc_color,
    })),
  );

const removeDuplicatedShifts = (schedules: ISchedule[]): ISchedule[] =>
  schedules.map(schedule => {
    const grouped = schedule.shifts.reduce<{ [shiftId: number]: IScheduleBlock[] }>((acc, shift) => {
      acc[shift.shiftId] = acc[shift.shiftId] ? [...acc[shift.shiftId], shift] : [shift];
      return acc;
    }, {});

    const shifts = Object.values(grouped).map(shifts => {
      if (shifts.length === 1) return shifts[0];

      return shifts.sort((a, b) => a.shiftAssnId - b.shiftAssnId).pop() as IScheduleBlock;
    });

    return { ...schedule, shifts };
  });

export { transformHeadcountShifts, removeDuplicatedShifts };
